import { useState, useEffect } from 'react'
import { Container, Grid, TextField, Button, Typography, createTheme, Box, Link, InputLabel, FormControl, Select, MenuItem, OutlinedInput } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { getAuth, sendPasswordResetEmail } from "firebase/auth";
import AppAppBar2 from '../components/AppBar2'
import ProductHeroLayout from '../components/ProductHeroLayout';
import { palette } from '@mui/system'
import { useFetchNoUser } from '../hooks/useFetchNoUser'
import CircularProgress from '@mui/material/CircularProgress';
import SelectNationality from '../components/SelectNationality'
import { NatOutlined } from '@mui/icons-material';
import validator from 'validator'
import SelectTitle from '../components/SelectTitle'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import SelectRace from '../components/SelectRace'
import SelectSALang from '../components/SelectSALang'
export default function RegisterUser() {



    const [backgroundImage, setBackgroundImage] = useState('../img/BannerDistance.jpg')


    const { postData, error, errorMessage, data: checkUserSuccessfull, isPending } = useFetchNoUser('https://dcregapi.bi-oss.co.za/user/checkuser', 'POST')
    const { postData: postData2, error: error2, errorMessage: errorMessage2, data: checkExistingParent, isPending: isPending2 } = useFetchNoUser('https://dcregapi.bi-oss.co.za/user/checkexisting/email', 'POST')
    const { postData: postData3, error: error3, errorMessage: errorMessage3, data: checkParentIDPass, isPending: isPending3 } = useFetchNoUser('https://dcregapi.bi-oss.co.za/user/checkexisting/idpass', 'POST')
    const { postData: postData4, error: error4, errorMessage: errorMessage4, data: checkOTP, isPending: isPending4 } = useFetchNoUser('https://dcregapi.bi-oss.co.za/user/checkexisting/verifyotp', 'POST')

    const { postData: postData5, error: error5, errorMessage: errorMessage5, data: newExitingUser, isPending: isPending5 } = useFetchNoUser('https://dcregapi.bi-oss.co.za/user/checkexisting/create', 'POST')

    const { postData: postData6, error: error6, errorMessage: errorMessage6, data: checknewIDPass, isPending: isPending6 } = useFetchNoUser('https://dcregapi.bi-oss.co.za/user/checknew/idpass', 'POST')

    const { postData: postData7, error: error7, errorMessage: errorMessage7, data: checknewotp, isPending: isPending7 } = useFetchNoUser('https://dcregapi.bi-oss.co.za/user/checknew/verifyotp', 'POST')

    const { postData: postData8, error: error8, errorMessage: errorMessage8, data: newparentaccount, isPending: isPending8 } = useFetchNoUser('https://dcregapi.bi-oss.co.za/user/checknew/createaccount', 'POST')




    const navigate = useNavigate()
    const [email, setEmail] = useState('')
    const [pid, setPid] = useState('')
    const [succ, setSucc] = useState('')

    const [createNew, setCreateNew] = useState(0)
    const [existingParent, setExistingParent] = useState(0)


    const [password, setPassword] = useState("")
    const [otp, setOTP] = useState('')
    const [otpSent, setOTPSent] = useState(0)
    const [idpass, setIdPass] = useState('')

    const [nation, setNation] = useState('South African')
    const [resend, setResend] = useState(0)
    const [enterPass, setEnterPass] = useState(0)
    const [errorPass, setErrorPass] = useState('')
    const [successPass, setSuccessPass] = useState('')

    const [title, setTitle] = useState('')
    const [fname, setFname] = useState('')
    const [lname, setLname] = useState('')
    const [dob, setDob] = useState('')
    const [gender, setGender] = useState('')
    const [raceId, setRaceId] = useState('')
    const [saMobile, setSaMobile] = useState('')
    const [intMobile, setIntMobile] = useState('')
    const [workTel, setWorkTel] = useState('')
    const [homeTel, setHomeTel] = useState('')
    const [languageId, setLanguageId] = useState('')
    const [address, setAddress] = useState('')

    const validate = (value) => {

        if (validator.isStrongPassword(value, {
            minLength: 8, minLowercase: 1,
            minUppercase: 1, minNumbers: 1, minSymbols: 1
        })) {
            setErrorPass('')
            setSuccessPass('Password strength: Secure.')
            setPassword(value)

        } else {
            setSuccessPass('')
            setErrorPass('Password strength: Weak')

        }
    }

    const handleSubmit = (e) => {
        e.preventDefault()

        postData({
            email,

        })
    }

    useEffect(() => {
        if (checkUserSuccessfull) {
            postData2({
                email,

            })
        }
    }, [checkUserSuccessfull])


    useEffect(() => {

        if (checkExistingParent) {

            if (checkExistingParent.pid > 0) {
                setPid(checkExistingParent.pid)
                setExistingParent(1)

            } else {
                setCreateNew(1)
            }
        }

    }, [checkExistingParent])


    const handleSubmit2 = (e) => {
        e.preventDefault()
        postData3({
            email, pid, idpass
        })
    }


    const resendOTP = (e) => {

        postData3({
            email, pid, idpass
        })
        setResend(1)
    }


    useEffect(() => {
        if (checkParentIDPass) {
            setOTPSent(1)
        }
    }, [checkParentIDPass])


    const handleSubmit3 = (e) => {
        e.preventDefault()
        postData4({
            otp, pid
        })
    }

    useEffect(() => {
        if (checkOTP) {
            setEnterPass(1)
        }
    }, [checkOTP])

    const handleSubmit4 = (e) => {
        e.preventDefault()
        postData5({
            pid, email, password
        })
    }

    useEffect(() => {
        if (newExitingUser) {
            setSucc(1)
        }
    }, [newExitingUser])

    const handleSubmit5 = (e) => {
        e.preventDefault()
        postData6({

            idpass, dob, email, fname, lname
        })
    }


    useEffect(() => {
        if (checknewIDPass) {
            setOTPSent(1)

        }
    }, [checknewIDPass])




    const resendOTP2 = (e) => {

        postData6({

            idpass, dob, email, fname, lname
        })
        setResend(1)
    }


    const handleSubmit6 = (e) => {
        e.preventDefault()
        postData7({

            idpass, dob, otp
        })

    }


    useEffect(() => {
        if (checknewotp) {
            setEnterPass(1)
        }
    }, [checknewotp])


    useEffect(() => {
        if (saMobile && nation === "South African") {

            setIntMobile(27 + saMobile.substring(1))


        }

    }, [saMobile])


    const handleSubmit7 = (e) => {
        e.preventDefault()

        postData8({

            email,
            idpass,
            nation,
            title,
            fname,
            lname,
            dob,
            gender,
            raceId,
            languageId,
            address,
            saMobile,
            workTel,
            intMobile,
            homeTel,
            password



        })

    }

    useEffect(() => {
        if (newparentaccount) {
            setSucc(1)
        }
    }, [newparentaccount])

    return (

        <>

            <AppAppBar2 />
            <Box sx={{
                backgroundColor: 'primary.light', minHeight: '100vh'
            }}>



                {!existingParent && !createNew && !succ && (

                    <>

                        <Box
                            display="flex"
                            justifyContent="center"
                            alignItems="center"

                        >

                            <Box mb={5} />
                            <Container maxWidth="xs" disableGutters align="center" top="50%" sx={{ backgroundColor: 'white', opacity: '0.7', border: 'Solid', borderWidth: '5px', borderColor: 'primary.main', padding: '30px', borderRadius: 3, marginTop: 3 }}>

                                <form onSubmit={handleSubmit}>
                                    <Box mb={5} />
                                    <Box mb={3} />
                                    <Typography
                                        variant="h3"
                                        color="textSecondary"
                                        component="h2"
                                        gutterBottom

                                    >
                                        Register
                                    </Typography>
                                    <Box mb={2} />


                                    <Typography
                                        variant="paragraph"
                                        color="textSecondary"
                                        component="p"
                                        gutterBottom
                                        fontFamily={'Arial'}

                                    >
                                        To register an account, a parent or guardian will need to enter their email address below and follow the prompts.

                                    </Typography>

                                    <Typography
                                        variant="paragraph"
                                        color="textSecondary"
                                        component="p"
                                        gutterBottom
                                        fontFamily={'Arial'}

                                    >
                                        If you are an existing BIDC parent or guardian without an online registration login, simply enter the email address you supplied during student registration and follow the prompts below.
                                    </Typography>

                                    <Box mb={2} />
                                    {!isPending && !isPending2 &&
                                        <TextField
                                            id="emailbox"
                                            label="Email Address:"
                                            variant="outlined"
                                            type="email"
                                            required
                                            onChange={(e) => setEmail(e.target.value)}
                                            value={email}
                                            fullWidth
                                            autoComplete='email'
                                            autoFocus
                                            inputProps={{ style: { textAlign: 'center' } }}
                                        />}


                                    {(isPending || isPending2) &&
                                        <TextField
                                            id="emailbox"
                                            label="Email Address:"
                                            variant="outlined"
                                            type="email"
                                            required
                                            disabled
                                            value={email}
                                            fullWidth
                                            autoComplete='email'
                                            autoFocus

                                        />}





                                    <Box mb={2} />
                                    {error && !errorMessage && <p className='error'>Service currently offline. Please try again later.</p>}
                                    {errorMessage && <p className='error'>{errorMessage}</p>}


                                    {!isPending && !isPending2 && <Button variant="contained" type="submit" fullWidth>Submit</Button>}

                                    {(isPending || isPending2) && <Button variant="contained" disabled fullWidth><CircularProgress /></Button>}
                                    <Box mb={3} />




                                    <Link href="../login">Login?</Link>
                                    <Box mb={2} />
                                </form>
                            </Container>


                        </Box>



                    </>
                )}
                {existingParent > 0 && !succ && (
                    <>

                        <Box
                            display="flex"
                            justifyContent="center"
                            alignItems="center"

                        >
                            <Box mb={5} />
                            {!otpSent && (
                                <>
                                    <Container maxWidth="xs" disableGutters align="center" top="50%" sx={{ backgroundColor: 'white', opacity: '0.7', border: 'Solid', borderWidth: '5px', borderColor: 'primary.main', padding: '30px', borderRadius: 3, marginTop: 3 }}>

                                        <form onSubmit={handleSubmit2}>
                                            <Box mb={5} />
                                            <Box mb={3} />

                                            <Typography
                                                variant="h4"
                                                color="textSecondary"
                                                component="h4"
                                                gutterBottom

                                            >
                                                Existing Parent or Guardian
                                            </Typography>

                                            <Typography
                                                variant="h5"
                                                color="textSecondary"
                                                component="h5"
                                                gutterBottom

                                            >
                                                Verification Step 1/2:
                                            </Typography>
                                            <Box mb={2} />

                                            <Typography
                                                variant="paragraph"
                                                color="textSecondary"
                                                component="p"
                                                gutterBottom
                                                fontFamily={'Arial'}

                                            >
                                                A parent or guardian account matching this email address has been found. To verify this is you, please enter your RSA Identification Number or International Passport Number supplied to British International Colleges and Schools.

                                            </Typography>

                                            <Box mb={2} />
                                            <SelectNationality nation={nation} setNation={setNation} />
                                            <Box mb={2} />
                                            {nation === "South African" &&
                                                <TextField

                                                    id="idpass"
                                                    label="RSA ID/Birth Certificate Number (13 Digits)"
                                                    onChange={(e) => setIdPass(e.target.value)}
                                                    content="center"
                                                    value={idpass}
                                                    fullWidth
                                                    required
                                                    inputProps={{ minLength: 13, maxLength: 13, pattern: "[0-9]+", style: { textAlign: 'center' } }}
                                                    autoComplete='nope'

                                                />
                                            }

                                            {
                                                nation !== "South African" &&
                                                <TextField

                                                    id="idpass"
                                                    label="Passport Number (min 6)"
                                                    onChange={(e) => setIdPass(e.target.value)}
                                                    value={idpass}
                                                    fullWidth
                                                    required
                                                    inputProps={{ minLength: 6, maxLength: 20, style: { textAlign: 'center' } }}
                                                    autoComplete='nope'
                                                />
                                            }





                                            <Box mb={2} />
                                            {error3 && !errorMessage3 && <p className='error'>Service currently offline. Please try again later.</p>}
                                            {errorMessage3 && <p className='error'>{errorMessage3}</p>}


                                            {!isPending3 && <Button variant="contained" type="submit" fullWidth>Submit</Button>}

                                            {isPending3 && <Button variant="contained" disabled fullWidth><CircularProgress /></Button>}
                                            <Box mb={3} />




                                            <Link href="../login">Login?</Link>
                                            <Box mb={2} />
                                        </form>
                                    </Container>
                                </>
                            )}

                            {otpSent > 0 && !enterPass && (
                                <Container maxWidth="xs" disableGutters align="center" top="50%" sx={{ backgroundColor: 'white', opacity: '0.7', border: 'Solid', borderWidth: '5px', borderColor: 'primary.main', padding: '30px', borderRadius: 3, marginTop: 3 }}>

                                    <form onSubmit={handleSubmit3}>
                                        <Box mb={5} />
                                        <Box mb={3} />

                                        <Typography
                                            variant="h4"
                                            color="textSecondary"
                                            component="h4"
                                            gutterBottom

                                        >
                                            Existing Parent or Guardian
                                        </Typography>

                                        <Typography
                                            variant="h5"
                                            color="textSecondary"
                                            component="h5"
                                            gutterBottom

                                        >
                                            Verification Step 2/2:
                                        </Typography>
                                        <Box mb={2} />

                                        <Typography
                                            variant="paragraph"
                                            color="textSecondary"
                                            component="p"
                                            gutterBottom
                                            fontFamily={'Arial'}

                                        >
                                            An email OTP has been sent to your account. Please enter the OTP below to verify your account.
                                        </Typography>

                                        <Box mb={2} />
                                        <TextField
                                            id="otp"
                                            label="Enter OTP:"
                                            variant="outlined"
                                            type="numbers"
                                            required
                                            onChange={(e) => setOTP(e.target.value)}
                                            value={otp}
                                            fullWidth

                                            autoFocus
                                            inputProps={{ style: { textAlign: 'center' } }}
                                        />



                                        <Box mb={2} />
                                        {error4 && !errorMessage4 && <p className='error'>Service currently offline. Please try again later.</p>}
                                        {errorMessage4 && <p className='error'>{errorMessage4}</p>}


                                        {!isPending4 && <Button variant="contained" type="submit" fullWidth>Submit OTP</Button>}

                                        {isPending4 && <Button variant="contained" disabled fullWidth><CircularProgress /></Button>}
                                        <Box mb={3} />
                                        {!resend && (
                                            <Typography
                                                variant="paragraph"
                                                color="textSecondary"
                                                component="p"
                                                gutterBottom
                                                fontFamily={'Arial'}

                                            >
                                                OR
                                            </Typography>

                                        )}

                                        <Box mb={3} />
                                        {(!isPending3 || !isPending4) && !resend && <Button variant="contained" onClick={(e) => resendOTP()} fullWidth>Resend OTP</Button>}
                                        {resend === 1 && (<Typography
                                            variant="paragraph"
                                            color="textSecondary"
                                            component="p"
                                            gutterBottom
                                            fontFamily={'Arial'}

                                        >
                                            OTP resent via email to {email}
                                        </Typography>)}


                                        <Box mb={2} />
                                    </form>
                                </Container>
                            )}

                            {enterPass > 0 && (

                                <>
                                    <Container maxWidth="xs" disableGutters align="center" top="50%" sx={{ backgroundColor: 'white', opacity: '0.7', border: 'Solid', borderWidth: '5px', borderColor: 'primary.main', padding: '30px', borderRadius: 3, marginTop: 3 }}>

                                        <form onSubmit={handleSubmit4}>
                                            <Box mb={5} />
                                            <Box mb={3} />

                                            <Typography
                                                variant="h4"
                                                color="textSecondary"
                                                component="h4"
                                                gutterBottom

                                            >
                                                Existing Parent or Guardian
                                            </Typography>

                                            <Typography
                                                variant="h5"
                                                color="textSecondary"
                                                component="h5"
                                                gutterBottom

                                            >
                                                Create Account
                                            </Typography>
                                            <Box mb={2} />

                                            <Typography
                                                variant="paragraph"
                                                color="textSecondary"
                                                component="p"
                                                gutterBottom
                                                fontFamily={'Arial'}

                                            >
                                                Please enter a password for your account.
                                            </Typography>
                                            <Typography
                                                variant="paragraph"
                                                color="textSecondary"
                                                component="p"
                                                gutterBottom
                                                fontFamily={'Arial'}

                                            >
                                                Password minimum requirements:
                                            </Typography>
                                            <Box mb={2} />

                                            <Typography
                                                variant="paragraph"
                                                color="textSecondary"
                                                component="p"
                                                gutterBottom
                                                fontFamily={'Arial'}
                                                textAlign="left"
                                            >

                                                <ul>
                                                    <li>Minimum of 8 character</li>
                                                    <li>1 Uppercase character</li>
                                                    <li>1 Lowercase character</li>
                                                    <li>1 Numeric Character (Number)</li>
                                                    <li>1 Symbol (special character example: !,@,#,$)</li>
                                                </ul>
                                            </Typography>


                                            <TextField

                                                id="password"
                                                label="Enter New Password"
                                                onChange={(e) => validate(e.target.value)}

                                                fullWidth
                                                required

                                                type="password"
                                                autoComplete='nope'
                                                inputProps={{ maxLength: 100, minLength: 8, style: { textAlign: 'center' } }}
                                            />



                                            <Box mb={2} />
                                            {errorPass && <p className='error'>{errorPass}</p>}
                                            {successPass && (
                                                <TextField

                                                    id="Notification"
                                                    InputProps={{
                                                        readOnly: true,

                                                    }}
                                                    value={successPass}
                                                    fullWidth
                                                    required
                                                    sx={{ borderRadius: 1, backgroundColor: "success.main", input: { color: 'white', textAlign: 'center' } }}
                                                />
                                            )}
                                            <Box mb={2} />

                                            {error5 && !errorMessage5 && <p className='error'>Service currently offline. Please try again later.</p>}
                                            {errorMessage5 && <p className='error'>{errorMessage5}</p>}


                                            {!isPending5 && !errorPass && <Button variant="contained" type="submit" fullWidth>Create Account</Button>}
                                            {errorPass && <Button variant="contained" disabled fullWidth>Create Account</Button>}
                                            {isPending5 && <Button variant="contained" disabled fullWidth><CircularProgress /></Button>}
                                            <Box mb={3} />





                                            <Box mb={2} />
                                        </form>
                                    </Container>

                                </>
                            )}

                        </Box>

                    </>

                )}




                {succ > 0 && (
                    <>
                        <Box
                            display="flex"
                            justifyContent="center"
                            alignItems="center"

                        >
                            <Box mb={5} />

                            <Container maxWidth="xs" disableGutters align="center" top="50%" sx={{ backgroundColor: 'white', opacity: '0.7', border: 'Solid', borderWidth: '5px', borderColor: 'primary.main', padding: '30px', borderRadius: 3, marginTop: 3 }}>

                                <form >
                                    <Box mb={5} />
                                    <Box mb={3} />
                                    <Typography
                                        variant="h3"
                                        color="textSecondary"
                                        component="h2"
                                        gutterBottom

                                    >
                                        Register
                                    </Typography>
                                    <Box mb={2} />


                                    <Typography
                                        variant="paragraph"
                                        color="success.main"
                                        component="p"
                                        gutterBottom
                                        fontFamily={'Arial'}

                                    >
                                        Your account has been created.
                                    </Typography>
                                    <Typography
                                        variant="paragraph"
                                        color="success.main"
                                        component="p"
                                        gutterBottom
                                        fontFamily={'Arial'}

                                    >
                                        Please login to continue with your course purchases.
                                    </Typography>
                                    <Box mb={2} />


                                    <Button variant="contained" href="../login" fullWidth>Login</Button>





                                    <Box mb={2} />
                                </form>
                            </Container>


                        </Box>



                    </>

                )}


                {createNew > 0 && !succ && (

                    <>


                        <Box
                            display="flex"
                            justifyContent="center"
                            alignItems="center"

                        >
                            <Box mb={5} />
                            {!otpSent && (
                                <>


                                    <Container maxWidth="xs" disableGutters align="center" top="50%" sx={{ backgroundColor: 'white', opacity: '0.7', border: 'Solid', borderWidth: '5px', borderColor: 'primary.main', padding: '30px', borderRadius: 3, marginTop: 3 }}>

                                        <form onSubmit={handleSubmit5}>
                                            <Box mb={5} />
                                            <Box mb={3} />
                                            <Typography
                                                variant="h3"
                                                color="textSecondary"
                                                component="h2"
                                                gutterBottom

                                            >
                                                Register Account
                                            </Typography>
                                            <Box mb={2} />



                                            <Typography
                                                variant="paragraph"
                                                color="primary.main"
                                                component="p"
                                                gutterBottom
                                                fontFamily={'Arial'}

                                            >
                                                Please enter your details below.



                                            </Typography>

                                            <Box mb={2} />


                                            <Box mb={2} />





                                            <TextField
                                                id="emailbox"
                                                label="Email/Username:"
                                                variant="outlined"
                                                type="email"
                                                required
                                                disabled
                                                value={email}
                                                fullWidth
                                                autoComplete='email'
                                                autoFocus
                                                inputProps={{ style: { textAlign: 'center' } }}
                                            />

                                            <Box mb={2} />
                                            <SelectNationality nation={nation} setNation={setNation} />
                                            <Box mb={2} />
                                            {nation === "South African" &&
                                                <TextField

                                                    id="idpass"
                                                    label="RSA ID/Birth Certificate Number (13 Digits)"
                                                    onChange={(e) => setIdPass(e.target.value)}
                                                    content="center"
                                                    value={idpass}
                                                    fullWidth
                                                    required
                                                    inputProps={{ minLength: 13, maxLength: 13, pattern: "[0-9]+", style: { textAlign: 'center' } }}
                                                    autoComplete='nope'

                                                />
                                            }

                                            {
                                                nation !== "South African" &&
                                                <TextField

                                                    id="idpass"
                                                    label="Passport Number (min 6)"
                                                    onChange={(e) => setIdPass(e.target.value)}
                                                    value={idpass}
                                                    fullWidth
                                                    required
                                                    inputProps={{ minLength: 6, maxLength: 20, style: { textAlign: 'center' } }}
                                                    autoComplete='nope'
                                                />
                                            }


                                            <Box mb={2} />


                                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                <DatePicker
                                                    label="Parent DOB (YYYY/MM/DD)"
                                                    inputFormat="yyyy/MM/dd"
                                                    value={dob}
                                                    onChange={(value) => setDob(value)}
                                                    renderInput={(params) => <TextField {...params} fullWidth />}
                                                    inputProps={{ style: { textAlign: 'center' } }}
                                                />

                                            </LocalizationProvider>

                                            <Box mb={2} />

                                            <SelectTitle title={title} setTitle={setTitle} />
                                            <Box mb={2} />
                                            <TextField

                                                id="fname"
                                                label="Parent First Names"
                                                value={fname}
                                                fullWidth
                                                required
                                                onChange={(e) => setFname(e.target.value)}
                                                autoComplete='nope'
                                                inputProps={{ maxLength: 100, minLength: 3, style: { textTransform: "capitalize", textAlign: 'center' } }}
                                            />
                                            <Box mb={2} />

                                            <TextField

                                                id="lname"
                                                label="Parent Last Name"
                                                value={lname}
                                                fullWidth
                                                required
                                                onChange={(e) => setLname(e.target.value)}
                                                autoComplete='nope'
                                                inputProps={{ maxLength: 100, minLength: 3, style: { textTransform: "capitalize", textAlign: 'center' } }}
                                            />

                                            <Box mb={2} />

                                            <FormControl fullWidth>
                                                <InputLabel id="genderL">Gender*</InputLabel>

                                                <Select

                                                    labelId="genderL"
                                                    id="Gender"
                                                    value={gender}
                                                    onChange={(e) => setGender(e.target.value)}
                                                    input={<OutlinedInput label="genderL" />}
                                                    required

                                                >
                                                    <MenuItem value="M">Male</MenuItem>
                                                    <MenuItem value="F">Female</MenuItem>

                                                </Select>
                                            </FormControl>
                                            <Box mb={2} />


                                            <SelectRace setRaceId={setRaceId} raceId={raceId} />
                                            <Box mb={2} />



                                            <TextField

                                                id="saMobile"
                                                label="Parent SA Mobile/Comms"
                                                onChange={(e) => setSaMobile(e.target.value)}
                                                value={saMobile}
                                                fullWidth
                                                type="tel"
                                                inputProps={{ maxLength: 10, minLength: 10, style: { textAlign: 'center' } }}
                                                autoComplete='nope'
                                                required
                                            />
                                            <Box mb={2} />

                                            <Box mb={2} />
                                            <TextField

                                                id="workTel"
                                                label="Work Tel"
                                                value={workTel}
                                                fullWidth
                                                type="tel"
                                                inputProps={{ maxLength: 15, minLength: 10, style: { textAlign: 'center' } }}
                                                onChange={(e) => setWorkTel(e.target.value)}
                                                required
                                                autoComplete='nope'
                                            />
                                            <Box mb={2} />
                                            <TextField

                                                id="homeTel"
                                                label="Home Tel"
                                                value={homeTel}
                                                fullWidth
                                                type="tel"
                                                inputProps={{ maxLength: 15, minLength: 10, style: { textAlign: 'center' } }}
                                                onChange={(e) => setHomeTel(e.target.value)}
                                                required
                                                autoComplete='nope'
                                            />
                                            <Box mb={2} />
                                            <SelectSALang languageId={languageId} setLanguageId={setLanguageId} label="Home Language" />

                                            <Box mb={2} />
                                            <TextField

                                                id="postal"
                                                label="Postal Address"
                                                value={address}
                                                fullWidth
                                                required
                                                onChange={(e) => setAddress(e.target.value)}
                                                autoComplete='nope'
                                                inputProps={{ maxLength: 200, minLength: 3, style: { textTransform: "capitalize", textAlign: 'center' } }}
                                            />


                                            <Box mb={2} />
                                            {error6 && !errorMessage6 && <p className='error'>Service currently offline. Please try again later.</p>}
                                            {errorMessage6 && <p className='error'>{errorMessage6}</p>}

                                            <Box mb={2} />

                                            {dob && !isPending6 && (

                                                <Button variant="contained" type="submit" fullWidth>Continue</Button>
                                            )}

                                            {!dob && !isPending6 && (

                                                <Button variant="contained" disabled fullWidth>Continue</Button>
                                            )}

                                            {isPending6 && <Button variant="contained" disabled fullWidth><CircularProgress /></Button>}
                                            <Box mb={2} />
                                        </form>
                                    </Container>
                                </>
                            )}


                            {otpSent > 0 && !enterPass && (
                                <Container maxWidth="xs" disableGutters align="center" top="50%" sx={{ backgroundColor: 'white', opacity: '0.7', border: 'Solid', borderWidth: '5px', borderColor: 'primary.main', padding: '30px', borderRadius: 3, marginTop: 3 }}>

                                    <form onSubmit={handleSubmit6}>
                                        <Box mb={5} />
                                        <Box mb={3} />

                                        <Typography
                                            variant="h4"
                                            color="textSecondary"
                                            component="h4"
                                            gutterBottom

                                        >
                                            Register Account
                                        </Typography>

                                        <Typography
                                            variant="h5"
                                            color="textSecondary"
                                            component="h5"
                                            gutterBottom

                                        >
                                            Verification
                                        </Typography>
                                        <Box mb={2} />

                                        <Typography
                                            variant="paragraph"
                                            color="textSecondary"
                                            component="p"
                                            gutterBottom
                                            fontFamily={'Arial'}

                                        >
                                            An email OTP has been sent to your account. Please enter the OTP below to verify your account.
                                        </Typography>

                                        <Box mb={2} />
                                        <TextField
                                            id="otp"
                                            label="Enter OTP:"
                                            variant="outlined"
                                            type="numbers"
                                            required
                                            onChange={(e) => setOTP(e.target.value)}
                                            value={otp}
                                            fullWidth

                                            autoFocus
                                            inputProps={{ style: { textAlign: 'center' } }}
                                        />



                                        <Box mb={2} />
                                        {error7 && !errorMessage7 && <p className='error'>Service currently offline. Please try again later.</p>}
                                        {errorMessage7 && <p className='error'>{errorMessage7}</p>}


                                        {!isPending7 && <Button variant="contained" type="submit" fullWidth>Submit OTP</Button>}

                                        {isPending7 && <Button variant="contained" disabled fullWidth><CircularProgress /></Button>}
                                        <Box mb={3} />
                                        {!resend && (
                                            <Typography
                                                variant="paragraph"
                                                color="textSecondary"
                                                component="p"
                                                gutterBottom
                                                fontFamily={'Arial'}

                                            >
                                                OR
                                            </Typography>

                                        )}

                                        <Box mb={3} />
                                        {(!isPending6 || !isPending7) && !resend && <Button variant="contained" onClick={(e) => resendOTP2()} fullWidth>Resend OTP</Button>}
                                        {resend === 1 && (<Typography
                                            variant="paragraph"
                                            color="textSecondary"
                                            component="p"
                                            gutterBottom
                                            fontFamily={'Arial'}

                                        >
                                            OTP resent via email to {email}
                                        </Typography>)}


                                        <Box mb={2} />
                                    </form>
                                </Container>
                            )}


                            {enterPass > 0 && (

                                <>
                                    <Container maxWidth="xs" disableGutters align="center" top="50%" sx={{ backgroundColor: 'white', opacity: '0.7', border: 'Solid', borderWidth: '5px', borderColor: 'primary.main', padding: '30px', borderRadius: 3, marginTop: 3 }}>

                                        <form onSubmit={handleSubmit7}>
                                            <Box mb={5} />
                                            <Box mb={3} />



                                            <Typography
                                                variant="h5"
                                                color="textSecondary"
                                                component="h5"
                                                gutterBottom

                                            >
                                                Create Account
                                            </Typography>
                                            <Box mb={2} />

                                            <Typography
                                                variant="paragraph"
                                                color="textSecondary"
                                                component="p"
                                                gutterBottom
                                                fontFamily={'Arial'}

                                            >
                                                Please enter a password for your account.
                                            </Typography>

                                            <Box mb={2} />
                                            <TextField

                                                id="password"
                                                label="Enter New Password (Alphanumeric & Minimum 8 Charaters)"
                                                onChange={(e) => validate(e.target.value)}

                                                fullWidth
                                                required

                                                type="password"
                                                autoComplete='nope'
                                                inputProps={{ maxLength: 100, minLength: 8, style: { textAlign: 'center' } }}
                                            />



                                            <Box mb={2} />
                                            {errorPass && <p className='error'>{errorPass}</p>}
                                            {successPass && (
                                                <TextField

                                                    id="Notification"
                                                    InputProps={{
                                                        readOnly: true,

                                                    }}
                                                    value={successPass}
                                                    fullWidth
                                                    required
                                                    sx={{ borderRadius: 1, backgroundColor: "success.main", input: { color: 'white', textAlign: 'center' } }}
                                                />
                                            )}
                                            <Box mb={2} />

                                            {error8 && !errorMessage8 && <p className='error'>Service currently offline. Please try again later.</p>}
                                            {errorMessage8 && <p className='error'>{errorMessage8}</p>}


                                            {!isPending8 && !errorPass && password && <Button variant="contained" type="submit" fullWidth>Create Account</Button>}
                                            {(errorPass || !password) && <Button variant="contained" disabled fullWidth>Create Account</Button>}
                                            {isPending8 && <Button variant="contained" disabled fullWidth><CircularProgress /></Button>}
                                            <Box mb={3} />





                                            <Box mb={2} />
                                        </form>
                                    </Container>

                                </>
                            )}




                        </Box >



                    </>
                )
                }

            </Box>
        </>


    )
}
